require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-jchavarri-chrome-extension-starter-reason-react.json") })
        }
      }, "path---package-unpublished-jchavarri-chrome-extension-starter-reason-react");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-jchavarri-chrome-extension-starter-reason-react!./.cache/json/package-unpublished-jchavarri-chrome-extension-starter-reason-react.json
// module id = 948
// module chunks = 231608221292675